import { STATUS_OPTIONS } from "@/constants/site";

const STYLES = {
  new: { bg: "rgba(76,195,255,0.12)", border: "rgba(76,195,255,0.4)", color: "#8AD9FF" },
  "in-progress": {
    bg: "rgba(246,196,83,0.12)",
    border: "rgba(246,196,83,0.4)",
    color: "#F7D98A",
  },
  done: { bg: "rgba(43,213,118,0.12)", border: "rgba(43,213,118,0.4)", color: "#7CE8AC" },
  rejected: { bg: "rgba(255,90,122,0.12)", border: "rgba(255,90,122,0.4)", color: "#FF9DB1" },
};

export const StatusBadge = ({ status }) => {
  const style = STYLES[status] || STYLES.new;
  const label = STATUS_OPTIONS.find((s) => s.value === status)?.label || status;
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider"
      data-testid={`status-badge-${status}`}
      style={{
        background: style.bg,
        border: `1px solid ${style.border}`,
        color: style.color,
      }}
    >
      {label}
    </span>
  );
};
